/* GENERATED FILE — DO NOT EDIT.
 *
 * The section-format numbers a coach fills in, emitted from the type the phone compiles:
 *   HybridTrainer/Services/SectionFormatConfig.swift
 *
 * Regenerate:  KATA_EMIT_WEB_TOKENS=1 ./tools/engine-tests/run.sh
 * The harness gate `beta-the-section-formats-as-lived` regenerates this in memory on every
 * run and fails if it differs.
 *
 * `coach_workout_sections.format_config` stores these KEYS. A field typed in one unit and
 * stored in another carries `scale` (minutes typed, seconds stored → 60). `defaultValue` is
 * what a section gets the moment its format is picked; `isRequired` is what `validate`
 * refuses to save without. Per-exercise keys live on the exercise rows and are listed so
 * a reader keeps them when a section dictionary carries them.
 */

export type FormatField = {
  key: string;
  label: string;
  unit: string;
  scale: number;
  defaultValue: number | null;
  isRequired: boolean;
};

export const FORMAT_FIELDS: Readonly<Record<string, readonly FormatField[]>> = {
  straight_sets: [],
  superset: [],
  circuit: [
    { key: "rounds", label: "Rounds", unit: "rounds", scale: 1, defaultValue: 3, isRequired: true },
    { key: "rest_between_rounds_seconds", label: "Rest between rounds", unit: "sec", scale: 1, defaultValue: 60, isRequired: true },
  ],
  emom: [
    { key: "round_count", label: "Rounds", unit: "rounds", scale: 1, defaultValue: 10, isRequired: true },
    { key: "work_seconds", label: "Every", unit: "sec", scale: 1, defaultValue: 60, isRequired: false },
  ],
  amrap: [
    { key: "total_seconds", label: "Time cap", unit: "min", scale: 60, defaultValue: 600, isRequired: true },
  ],
  timed_interval: [
    { key: "rounds", label: "Rounds", unit: "rounds", scale: 1, defaultValue: 3, isRequired: true },
  ],
  for_time: [
    { key: "rounds", label: "Sets", unit: "sets", scale: 1, defaultValue: 3, isRequired: true },
    { key: "time_cap_seconds", label: "Time cap", unit: "min", scale: 60, defaultValue: null, isRequired: false },
  ],
};

/** Keys a format carries on an EXERCISE row rather than the section. */
export const PER_EXERCISE_KEYS: Readonly<Record<string, readonly string[]>> = {
  straight_sets: [],
  superset: [],
  circuit: [],
  emom: ["reps_per_minute"],
  amrap: [],
  timed_interval: ["rest_seconds", "work_seconds"],
  for_time: ["target_reps_per_round"],
};

/** LEGACY, READ ONLY. The iPhone builder wrote AMRAP and EMOM minutes under this key until
 *  2026-09-05; a reader resolves it (AMRAP → total_seconds × 60, EMOM → round_count) and a
 *  writer never names it. */
export const LEGACY_DURATION_MINUTES = "duration_minutes";
export const KEY_TOTAL_SECONDS = "total_seconds";
export const KEY_ROUND_COUNT = "round_count";
export const KEY_ROUNDS = "rounds";
export const KEY_WORK_SECONDS = "work_seconds";
export const KEY_REST_SECONDS = "rest_seconds";
export const KEY_REST_BETWEEN_ROUNDS_SECONDS = "rest_between_rounds_seconds";
export const KEY_TIME_CAP_SECONDS = "time_cap_seconds";
export const KEY_REPS_PER_MINUTE = "reps_per_minute";
